function readDefaultFilters(MassiaAuthService) {
	const user = MassiaAuthService.getAuthenticatedUser();
	if (!user) return null;
	const userId = user.id || user.userId || user.login;
	try {
		const raw = localStorage.getItem(`massia_default_filters_${userId}`);
		return raw ? JSON.parse(raw) : null;
	} catch (e) {
		return null;
	}
}

function applyValue(ngModel, scope, attrs, value) {
	ngModel.$setViewValue(value != null ? Number(value) : value);
	ngModel.$render();
	// Evaluate ng-change directly in scope — avoids reading stale DOM value
	if (attrs.ngChange) {
		scope.$eval(attrs.ngChange);
	}
	if (attrs.autoSearch) {
		scope.$eval(attrs.autoSearch);
	}
}

function applyIstevenValue(scope, attrs, id) {
	const items = attrs.inputModel ? scope.$eval(attrs.inputModel) : null;
	if (!items) return;
	const tickProp = attrs.tickProperty || 'selected';
	items.forEach((item) => (item[tickProp] = false));
	const outputModel = attrs.outputModel ? scope.$eval(attrs.outputModel) : null;
	if (outputModel && Array.isArray(outputModel)) {
		outputModel.length = 0;
	}
	if (id) {
		const match = items.find((item) => item.id == id);
		if (match) {
			match[tickProp] = true;
			if (outputModel && Array.isArray(outputModel)) {
				outputModel.push(match);
			}
			if (attrs.onItemClick) {
				scope.$eval(attrs.onItemClick, { data: match });
			}
		}
	} else if (attrs.onItemClick) {
		scope.$eval(attrs.onItemClick, { data: { id: null } });
	}
	if (attrs.autoSearch) {
		scope.$eval(attrs.autoSearch);
	}
}

function makeAutoDirective(key) {
	function directive(MassiaAuthService, $timeout, $parse, $rootScope) {
		return {
			restrict: 'A',
			require: '?ngModel',
			link(scope, element, attrs, ngModel) {
				const attrName = key === 'idSociete' ? 'autoSociete' : key === 'idSite' ? 'autoSite' : 'autoRegroupementSite';

				if (!$rootScope._autoFilterRegistry) $rootScope._autoFilterRegistry = { idSociete: 0, idSite: 0, idRegroupementSite: 0 };
				$rootScope._autoFilterRegistry[key]++;
				$rootScope.$broadcast('massiaAutoFilterRegistryChanged', $rootScope._autoFilterRegistry);
				scope.$on('$destroy', () => {
					$rootScope._autoFilterRegistry[key]--;
					$rootScope.$broadcast('massiaAutoFilterRegistryChanged', $rootScope._autoFilterRegistry);
				});

				// Suit dynamiquement la valeur de ng-attr-auto-societe/site (peut changer après le link si l'id est chargé en async)
				let active = attrs[attrName] !== 'false';
				attrs.$observe(attrName, (val) => {
					active = val !== 'false';
				});

				const isMassiaSelect = element[0].tagName.toLowerCase() === 'massia-select';

				function applyMassiaSelectValue(value) {
					const ctrl = element.controller('massiaSelect');
					if (!ctrl) return;
					if (value != null && value != 0) {
						ctrl.initialValue = String(value);
						ctrl.checkFirstValue();
					} else {
						ctrl.searchText = '';
						ctrl.ngModel = null;
					}
					if (attrs.ngModel) {
						$parse(attrs.ngModel).assign(scope, value != null ? Number(value) : value);
					}
					if (attrs.ngChange) scope.$eval(attrs.ngChange);
					if (attrs.autoSearch) scope.$eval(attrs.autoSearch);
				}

				function applyForElement(value) {
					if (!active) return;
					if (isMassiaSelect) {
						applyMassiaSelectValue(value);
					} else if (ngModel) {
						applyValue(ngModel, scope, attrs, value);
					} else if (attrs.inputModel) {
						applyIstevenValue(scope, attrs, value);
					}
				}

				$timeout(() => {
					if (!active) return;
					const data = readDefaultFilters(MassiaAuthService);
					if (!data || !data[key] || data[key] == 0) return;

					if (isMassiaSelect) {
						applyForElement(data[key]);
					} else if (ngModel) {
						applyValue(ngModel, scope, attrs, data[key]);
					} else if (attrs.inputModel) {
						// isteven-multi-select: watch until items are loaded
						const deregister = scope.$watch(
							() => scope.$eval(attrs.inputModel),
							(items) => {
								if (items && items.length) {
									deregister();
									applyIstevenValue(scope, attrs, data[key]);
								}
							}
						);
					}
				});

				const unsubscribe = scope.$on('massiaDefaultFiltersChanged', (_event, updated) => {
					const idKey = updated && updated[key] && updated[key] != 0 ? updated[key] : null;
					applyForElement(idKey);
				});

				scope.$on('$destroy', unsubscribe);
			}
		};
	}
	directive.$inject = ['MassiaAuthService', '$timeout', '$parse', '$rootScope'];
	return directive;
}

function makeHideIfDefaultDirective(...keys) {
	function directive(MassiaAuthService) {
		return {
			restrict: 'A',
			link(scope, element) {
				function update(data) {
					const hasDefault = keys.every((k) => data && data[k] && data[k] != 0);
					element.toggleClass('ng-hide', hasDefault);
				}

				update(readDefaultFilters(MassiaAuthService));

				const unsubscribe = scope.$on('massiaDefaultFiltersChanged', (_event, updated) => update(updated));
				scope.$on('$destroy', unsubscribe);
			}
		};
	}
	directive.$inject = ['MassiaAuthService'];
	return directive;
}

function makeHideIfNoDefaultDirective(...keys) {
	function directive(MassiaAuthService) {
		return {
			restrict: 'A',
			link(scope, element) {
				function update(data) {
					const hasDefault = keys.every((k) => data && data[k] && data[k] != 0);
					element.toggleClass('ng-hide', !hasDefault);
				}

				update(readDefaultFilters(MassiaAuthService));

				const unsubscribe = scope.$on('massiaDefaultFiltersChanged', (_event, updated) => update(updated));
				scope.$on('$destroy', unsubscribe);
			}
		};
	}
	directive.$inject = ['MassiaAuthService'];
	return directive;
}

export const autoSocieteDirective = makeAutoDirective('idSociete');
export const autoSiteDirective = makeAutoDirective('idSite');
export const autoRegroupementSiteDirective = makeAutoDirective('idRegroupementSite');

export const hideIfDefaultSocieteDirective = makeHideIfDefaultDirective('idSociete');
export const hideIfDefaultSiteDirective = makeHideIfDefaultDirective('idSite');
export const hideIfDefaultSocieteAndSiteDirective = makeHideIfDefaultDirective('idSociete', 'idSite');

export const hideIfNoDefaultSocieteDirective = makeHideIfNoDefaultDirective('idSociete');

function applyReadonlyState(element, locked) {
	if (element[0].tagName.toLowerCase() === 'massia-select') {
		const ctrl = element.controller('massiaSelect');
		if (ctrl) {
			ctrl.disabled = locked;
		}
		if (locked) {
			element.addClass('default-filter-readonly');
		} else {
			element.removeClass('default-filter-readonly');
		}
		return;
	}
	if (locked) {
		element.attr('disabled', 'disabled');
		element.attr('readonly', 'readonly');
		element.addClass('default-filter-readonly');
	} else {
		element.removeAttr('disabled');
		element.removeAttr('readonly');
		element.removeClass('default-filter-readonly');
	}
}

function makeAutoReadonlyDirective(key) {
	function directive(MassiaAuthService, $timeout) {
		return {
			restrict: 'A',
			link(scope, element, attrs) {
				const attrName = key === 'idSociete' ? 'autoSocieteReadonly' : key === 'idSite' ? 'autoSiteReadonly' : 'autoRegroupementSiteReadonly';

				if (attrs[attrName] == 'false') {
					//Désactive la directive complètement avec ng-attr
					return;
				}

				$timeout(() => {
					const data = readDefaultFilters(MassiaAuthService);
					if (!data || !data[key] || data[key] == 0) {
						//pas de valeurs par défaut = pas de readonly
						applyReadonlyState(element, false);
						return;
					} else {
						applyReadonlyState(element, true);
					}
				});

				const unsubscribe = scope.$on('massiaDefaultFiltersChanged', (_event, updated) => {
					const idKey = updated && updated[key] && updated[key] != 0 ? updated[key] : null;
					applyReadonlyState(element, idKey != null);
				});

				scope.$on('$destroy', unsubscribe);
			}
		};
	}
	directive.$inject = ['MassiaAuthService', '$timeout'];
	return directive;
}

export const autoSocieteReadonlyDirective = makeAutoReadonlyDirective('idSociete');
export const autoSiteReadonlyDirective = makeAutoReadonlyDirective('idSite');
export const autoRegroupementSiteReadonlyDirective = makeAutoReadonlyDirective('idRegroupementSite');
